import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { PartnershipCard, ValidationResponse } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface ValidatePartnershipCardParams extends DefaultHttpHeaders {}

@Injectable()
export class ValidatePartnershipCardService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Validate partner number card
   * Validate partner number card
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/postValidateNumberCard
   */
  validatePartnershipCard(
    body: PartnershipCard,
    params: ValidatePartnershipCardParams
  ): Observable<ValidationResponse> {
    return this.post<PartnershipCard, ValidationResponse>({
      suffix: '/comeround/applicationUtilities/validatePartnershipCard',
      body,
    });
  }
}
